import { createAction, props } from '@ngrx/store';
import { forgotPasswordType } from '../../core/models/Interfaces/forgotPassword';

export const forgotPasswordRequest = createAction(
  'forgot-password-request',
  props<{ forgotPasswordParams: forgotPasswordType }>(),
);

export const forgotPasswordReceived = createAction(
  'forgot-password-received',
  props<{ data: any }>(),
);

export const forgotPasswordFailed = createAction(
  'forgot-password-failed',
  props<{ error: any }>(),
);

export const resetForgotPasswordState = createAction(
  'reset-forgot-password-state',
);
